
import { useEffect, useState } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import { toast } from "react-toastify";

function ManageSign() {
    const [ldata, setLdata] = useState(null);
    const [previewImages, setPreviewImages] = useState({});
    const [formData, setFormData] = useState({
        departs: [],
        sign_department: '',
        selItem: {},
        alertMsg: '',
        alertMsgTyp: '',
        isAlert: false,
    });

    const initData = async () => {
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            const fd = new FormData();
            fd.append('cat_type', "department");
            fd.append('page_no', "none");
            fd.append('search_key', "");
            fd.append('par_by', 1 + "");

            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd);
                if (response.data.status && response.data.records) {
                    setFormData(prev => ({
                        ...prev,
                        departs: response.data.records
                    }));
                }
            } catch (error) {
                console.error(error);
            }
        }
    };

    const handleChange = (e, depId = null) => {
        const { name, value } = e.target;
        const key = depId || formData.sign_department;

        setFormData(prev => ({
            ...prev,
            selItem: {
                ...prev.selItem,
                [key]: {
                    ...prev.selItem[key],
                    [name]: value
                }
            }
        }));
    };

    const handleImageChange = (e, depId, type) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreviewImages(prev => ({
                    ...prev,
                    [depId]: {
                        ...prev[depId],
                        [type]: reader.result
                    }
                }));
            };
            reader.readAsDataURL(file);
        }
    };

    const handleChange1 = async (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        if (value === "all-department") {
            let allSignData = {};
            let allPreviews = {};

            for (let dep of formData.departs) {
                const fd = new FormData();
                fd.append('sign_department', dep.cat_id + "");
                try {
                    const res = await axios.post(AppConst.BASE_URL + AppConst.getSignByDepartUrl, fd);
                    console.log("this is ddd :" + JSON.stringify(res.data));
                    if (res.data.status && res.data.sign_dt) {
                        allSignData[dep.cat_id] = res.data.sign_dt;
                        allPreviews[dep.cat_id] = {
                            tech: res.data.sign_dt.sign_tech_sign ? AppConst.BASE_URL + res.data.sign_dt.sign_tech_sign : null,
                            doc: res.data.sign_dt.sign_doc_sign ? AppConst.BASE_URL + res.data.sign_dt.sign_doc_sign : null
                        };
                    }
                } catch (error) {
                    console.error(error);
                }
            }

            setFormData(prev => ({
                ...prev,
                selItem: allSignData
            }));
            setPreviewImages(allPreviews);
        } else {
            const fd = new FormData();
            fd.append('sign_department', value + "");
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getSignByDepartUrl, fd);
                console.log("this is kkkk : " + JSON.stringify(response.data));
                if (response.data.status) {
                    const sign_dt = response.data.sign_dt || {};
                    setFormData(prev => ({
                        ...prev,
                        selItem: {
                            [value]: sign_dt
                        }
                    }));

                    setPreviewImages(prev => ({
                        ...prev,
                        [value]: {
                            tech: sign_dt.sign_tech_sign ? AppConst.BASE_URL + sign_dt.sign_tech_sign : null,
                            doc: sign_dt.sign_doc_sign ? AppConst.BASE_URL + sign_dt.sign_doc_sign : null
                        }
                    }));
                }
            } catch (error) {
                console.error(error);
            }
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const departmentsToSubmit = formData.sign_department === 'all-department'
            ? formData.departs.map(dep => dep.cat_id)
            : [formData.sign_department];

        for (let depId of departmentsToSubmit) {
            const item = formData.selItem[depId];
            if (!item) continue;

            const fd = new FormData();
            fd.append('sign_id', item.sign_id || '');
            fd.append('sign_department', depId);
            fd.append('sign_tech_name', item.sign_tech_name || '');
            fd.append('sign_tech_id', item.sign_tech_id || '');
            fd.append('sign_quali', item.sign_quali || '');
            fd.append('sign_speci', item.sign_speci || '');
            fd.append('sign_doc_name', item.sign_doc_name || '');
            fd.append('sign_doc_id', item.sign_doc_id || '');
            fd.append('sign_doc_quali', item.sign_doc_quali || '');
            fd.append('sign_doc_spec', item.sign_doc_spec || '');
            fd.append('sign_user', ldata.user_id);

            const techInput = document.getElementById(`sign_tech_sign_${depId}`);
            const docInput = document.getElementById(`sign_doc_sign_${depId}`);
            if (techInput?.files[0]) fd.append('sign_tech_sign', techInput.files[0]);
            if (docInput?.files[0]) fd.append('sign_doc_sign', docInput.files[0]);

            try {
                const res = await axios.post(AppConst.BASE_URL + AppConst.addSignUrl, fd);
                setFormData(prev => ({
                    ...prev,
                    isAlert: true,
                    // alertMsg: res.data.success,
                    // alertMsgTyp: res.data.type
                }));
                toast.success(res.data.success);
            } catch (err) {
                setFormData(prev => ({
                    ...prev,
                    isAlert: true,
                    alertMsg: "Error occurred!",
                    alertMsgTyp: "danger"
                }));
            }
        }
    };

    useEffect(() => {
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            setLdata(parsed);
            initData();
        }
    }, []);

    const renderForm = (depId, depName) => {
        const sel = formData.selItem[depId] || {};
        console.log("Selected Item for depId " + depId + ": " + JSON.stringify(sel));
        const preview = previewImages[depId] || {};

        return (
            <div className="card mb-4" key={depId}>
                <div className="card-header"><h5>{depName}</h5></div>
                <div className="card-body">
                    <div className="row">
                        {/* Technician */}
                        <div className="col-md-6">
                            <h5>Lab Technician</h5>
                            <div className="mb-3"><label>Name</label>
                                <input type="text" className="form-control" name="sign_tech_name" value={sel.sign_tech_name || ''} onChange={(e) => handleChange(e, depId)} required />
                            </div>
                            <div className="mb-3"><label>ID</label>
                                <input type="text" className="form-control" name="sign_tech_id" value={sel.sign_tech_id || ''} onChange={(e) => handleChange(e, depId)}  />
                            </div>
                            <div className="mb-3"><label>Qualification</label>
                                <input type="text" className="form-control" name="sign_quali" value={sel.sign_quali || ''} onChange={(e) => handleChange(e, depId)}  />
                            </div>
                            <div className="mb-3"><label>Specialization</label>
                                <input type="text" className="form-control" name="sign_speci" value={sel.sign_speci || ''} onChange={(e) => handleChange(e, depId)} required />
                            </div>
                            <div className="mb-3"><label>Upload Signature</label>
                                <input type="file" className="form-control" id={`sign_tech_sign_${depId}`} onChange={(e) => handleImageChange(e, depId, 'tech')} />
                                {preview.tech && <img src={preview.tech} alt="Tech Signature" style={{ width: 100, height: 100, marginTop: 10 }} />}
                            </div>
                        </div>

                        {/* Doctor */}
                        <div className="col-md-6">
                            <h5>Doctor</h5>
                            <div className="mb-3"><label>Name</label>
                                <input type="text" className="form-control" name="sign_doc_name" value={sel.sign_doc_name || ''} onChange={(e) => handleChange(e, depId)} required />
                            </div>
                            <div className="mb-3"><label>ID</label>
                                <input type="text" className="form-control" name="sign_doc_id" value={sel.sign_doc_id || ''} onChange={(e) => handleChange(e, depId)}  />
                            </div>
                            <div className="mb-3"><label>Qualification</label>
                                <input type="text" className="form-control" name="sign_doc_quali" value={sel.sign_doc_quali || ''} onChange={(e) => handleChange(e, depId)}  />
                            </div>
                            <div className="mb-3"><label>Specialization</label>
                                <input type="text" className="form-control" name="sign_doc_spec" value={sel.sign_doc_spec || ''} onChange={(e) => handleChange(e, depId)} required />
                            </div>
                            <div className="mb-3"><label>Upload Signature</label>
                                <input type="file" className="form-control" id={`sign_doc_sign_${depId}`} onChange={(e) => handleImageChange(e, depId, 'doc')} />
                                {preview.doc && <img src={preview.doc} alt="Doc Signature" style={{ width: 100, height: 100, marginTop: 10 }} />}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="page-content">
            <div className="container-fluid">
                <div className="card">
                    <div className="card-body">
                        <h4 className="mb-4">Manage Signature</h4>
                        <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                                <label>Select Department</label>
                                <select className="form-control" name="sign_department" value={formData.sign_department} onChange={handleChange1} required>
                                    <option value="">Select Department</option>
                                    <option value="all-department">All Department</option>
                                    {formData.departs.map((item) => (
                                        <option key={item.cat_id} value={item.cat_id}>{item.cat_name}</option>
                                    ))}
                                </select>
                            </div>

                            {formData.sign_department === 'all-department'
                                ? formData.departs.map(dep => renderForm(dep.cat_id, dep.cat_name))
                                : renderForm(formData.sign_department, formData.departs.find(d => d.cat_id === formData.sign_department)?.cat_name)
                            }

                            {formData.isAlert && (
                                <div className={`alert alert-${formData.alertMsgTyp} mt-3`}>
                                    {formData.alertMsg}
                                </div>
                            )}

                            <div className="text-end">
                                <button type="submit" className="btn btn-primary">Update</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ManageSign;

